import { TextFieldModule } from '@angular/cdk/text-field';
import { NgModule } from '@angular/core';
import { ErrorStateMatcher } from '../core';
import { FormFieldModule } from '../form-field';
import { MatInputDirective } from './input.directive';

@NgModule({
  declarations: [MatInputDirective],
  imports: [TextFieldModule, FormFieldModule],
  exports: [
    TextFieldModule,
    // We re-export the `FormFieldModule` since `MatInputDirective` will almost always
    // be used together with `FormFieldModule`.
    FormFieldModule,
    MatInputDirective,
  ],
  providers: [ErrorStateMatcher],
})
export class InputModule {}
